import { getField, updateField } from 'vuex-map-fields'
import { authHeader } from '@/services/auth'
import axios from 'axios'
import {HTTP_HYPER_ESPACE_BACKEND} from "@/services/http-common";

const getDefaultFilter = () => ({
  page: 1,
  offset: 0,
  limit: 10,
  sort: '-DC',
  search: '', // Recherche
  annoncesDesactivees: false,
  annoncesActivees: true,
  annoncesModeles: null,
  annonceParente: null,
  annoncesVendues: false,
  stock: null,
  preset: 'enable'
})

const getPresetFilters = () => ({
  preset: 'enable'
})

export default {
  namespaced: true,
  state: {
    refreshProgramme: false,
    post: { code_postal_reel: 30 }, // dans le cas ou l'on crée ou édit une annonce
    tabs: [],
    filter: getDefaultFilter(),
    results: { total: -1, list: [] },
    quotaAndAnnoncesByCurrentUser: { quota: null, annoncesSelectionnees: 0 }// Stockage des derniers résultats pour accélérer le retour arrière
  },
  getters: {
    getPostField (state) {
      return getField(state.post)
    },
    getRefreshProgramme (state) {
      return state.refreshProgramme
    },
    getQuotaCurrentUser: state => state.quotaAndAnnoncesByCurrentUser.quota,
    getSelectedAdsCurrentUser: state => state.quotaAndAnnoncesByCurrentUser.annoncesSelectionnees
  },
  actions: {
    loadQuotaPerPortal (context, args) {
      const { idUser, idPortail } = args
      HTTP_HYPER_ESPACE_BACKEND.get(`/userQuotaPerPortal/${idUser}/${idPortail}`)
        .then((response) => {
          context.state.quotaAndAnnoncesByCurrentUser = response.data
        }).catch(error => {
          console.log({ type: 'error', message: error })
        })
    }
  },
  mutations: {
    updatePostField (state, field) {
      updateField(state.post, field)
    },
    setPost (state, post) {
      state.post = post
    },
    setTabs (state, tabs) {
      state.tabs = tabs
    },
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1 }
    },
    addFilter (state, filter) {
      state.filter = { ...state.filter, ...filter, page: 1 }
    },
    setQuotaAndAnnoncesByCurrentUser (state, { quota, annoncesSelectionnees }) {
      state.quotaAndAnnoncesByCurrentUser.quota = quota
      state.quotaAndAnnoncesByCurrentUser.annoncesSelectionnees = annoncesSelectionnees
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...filter
      }
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    },
    setRefreshProgramme (state, refreshProgramme) {
      state.refreshProgramme = refreshProgramme
    }
  }
}
